import { Component } from '@angular/core';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-proration',
  standalone: true,
  imports: [
    MatSidenavContainer,
    HoverMenuDirective,
    MatMenuTrigger,
    MatIconModule,
    MatMenuModule,
    MatButtonModule
  ],
  templateUrl: './proration.component.html',
  styleUrl: './proration.component.scss'
})
export class ProrationComponent {

}
